import KycCard from './KycCard';

export default KycCard;
